<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-simple-table dense style="border: 1px solid #d1d1d1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left caption">CODIGO</th>
                <th class="text-left caption">CUENTA</th>
                <th class="text-right caption">ENERO</th>
                <th class="text-right caption">FEBRERO</th>
                <th class="text-right caption">MARZO</th>
                <th class="text-right caption">ABRIL</th>
                <th class="text-right caption">MAYO</th>
                <th class="text-right caption">JUNIO</th>
                <th class="text-right caption">JULIO</th>
                <th class="text-right caption">AGOSTO</th>
                <th class="text-right caption">SEPTIEMBRE</th>
                <th class="text-right caption">OCTUBRE</th>
                <th class="text-right caption">NOVIEMBRE</th>
                <th class="text-right caption">DICIEMBRE</th>
                <th class="text-right caption">TOTAL</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="presupuesto in presupuestos" :key="presupuesto.id">
                <td class="text-left caption">{{ presupuesto.codigo }}</td>
                <td class="text-left caption">{{ presupuesto.nombre }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.enero) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.febrero) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.marzo) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.abril) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.mayo) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.junio) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.julio) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.agosto) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.septiembre) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.octubre) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.noviembre) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.diciembre) }}</td>
                <td class="text-right caption">{{ formatearNumero(presupuesto.total) }}</td>
              </tr>
              <tr>
                <td></td>
                <td class="text-left caption">TOTALES</td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.enero), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.febrero), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.marzo), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.abril), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.mayo), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.junio), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.julio), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.agosto), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.septiembre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.octubre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.noviembre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.diciembre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + parseFloat(b.total), 0).toFixed(2)) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatearNumero } from './../utils.js';

export default {
  name: 'TablaPresupuestos',
  props: {
    presupuestos: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatearNumero,
  },
};
</script>

<style>
</style>